<template>
  <v-flex>
    <v-layout
      align-center
      justify-content-between
      :justify-center="xsScreen"
      :wrap="xsScreen"
      :class="[xsScreen ? 'py-2' : '']"
    >
      <v-flex class="f-16">
        <p class="mb-0">
          {{ $t('family_card.document_section.post_meeting_consent_instruction.title') }}
        </p>
        <p class="mb-0 pl-2">
          {{ $t('family_card.document_section.post_meeting_consent_instruction.1') }}
        </p>
        <p class="mb-0 pl-2">
          {{ $t('family_card.document_section.post_meeting_consent_instruction.2') }}
        </p>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
    name: 'ConsentInstruction',
    computed: {
        xsScreen () {
            return this.$vuetify.breakpoint.xsOnly;
        }
    }
};
</script>

<style scoped></style>
